module.exports = __webpack_public_path__ + "img/banner-3.ba7102e0.jpg";